import { setTokenHeader } from "../../services/api";
import { SET_CURRENT_USER } from "../actionTypes";
import { addError, removeError } from "./errors";
import axios from "axios";

export function setCurrentUser(user) {
  return {
    type: SET_CURRENT_USER,
    user,
  };
}

export function setAuthorizationToken(token) {
  setTokenHeader(token);
}

export function logout() {
  return (dispatch) => {
    localStorage.clear();
    setAuthorizationToken(false);
    dispatch(setCurrentUser({}));
  };
}

export function authUser(type, userData) {
  return (dispatch) => {
    // wrap our thunk in a promise so we can wait for the API call
    return new Promise(async (resolve, reject) => {
      try {
        let result = await axios.post(`/api/auth/${type}`, userData);
        let response = result.data;
        let { token, validExistingSession, verifyTFA, isCurrentSessionValid, ...otherFields } = response;
        if (isCurrentSessionValid) {
          resolve({ isCurrentSessionValid, ...otherFields });
        } else {
          localStorage.setItem("jwtToken", token);
          setAuthorizationToken(token);
          dispatch(removeError());
          if (validExistingSession || verifyTFA) {
            resolve({ validExistingSession, verifyTFA, ...otherFields });
          } else {
            dispatch(setCurrentUser(otherFields));
            resolve({ validExistingSession: false, verifyTFA: false, ...otherFields });
          }
        }
      } catch (err) {
        console.error("[AuthUser] error inside auth call", err);
        let errorMsg = err.response && err.response.data ? err.response.data.error?.message : err.message;
        dispatch(addError(errorMsg || err));
        reject(err); // indicate the API call failed
      }
    });
  };
}
